

// import React, { useState, useEffect } from 'react';

// const LearningPathTFD = () => {
//     const [toggle, setToggle] = useState(null);
//     const [nestedToggle, setNestedToggle] = useState({});
//     const [data, setData] = useState([]);

//     const updateToggle = (id) => {
//         setToggle(toggle === id ? null : id);
//     };

//     const updateNestedToggle = (nestedId) => {
//         setNestedToggle((prevState) => ({
//             ...prevState,
//             [nestedId]: !prevState[nestedId],
//         }));
//     };

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const response = await fetch('your-api-url');
//                 const data = await response.json();
//                 setData(data); // Update the state with fetched data
//             } catch (error) {
//                 console.error('Error fetching data:', error);
//             }
//         };
//         fetchData();
//     }, []);
    
//     const listContent = [
//         {
//             id: 0,
//             title: " INTRODUCTION TO MECHANICAL ENGINEERING",
//             content: null,
//             nestedContent: [],
//         },
//         {
//             id: 1,
//             title: "Core Mechanical Engineering Principles ",
//             content: null,
//             nestedContent: [
//                 {
//                     id: 1,
//                     text: "•		Thermodynamics  ",
//                     dummyText: ["*	Laws of Thermodynamics: Overview of the 1st and 2nd laws", "*•	Heat and Work Interaction: Basics and applications in engineering."],
//                 },
//                 { 
//                     id: 2,
//                     text: "•		 Fluid Mechanics  ",
//                     dummyText: ["*				Properties of Fluids: Viscosity, density, and compressibility.", "*			Fundamentals of Fluid Statics and Dynamics: Bernoulli’s equation and practical applications.", "*	Job Opportunities, Roles, and Packages for Fresher.",],
//                 },
//                 {
//                     id: 3,
//                     text: "• Engineering Mechanics ",
//                     dummyText: ["*	Force Systems and Equilibrium: Basic concepts of statics","*	Kinematics and Kinetics: Motion, velocity, and acceleration."],
//                 },
//                 {
//                     id: 4,
//                     text: "•  Strength of Materials  ",
//                     dummyText: ["*		Stress and Strain: Elasticity, Hooke’s Law.","*	Applications: Basics of buckling, torsion, and structural safety."],
//                 },
//             ],
//         },
//         {
//             id: 2,
//             title: " Manufacturing Processes   ",
//             nestedContent: [
//                 {
//                     id: 1,
//                     text: "•	 	Casting and Molding ",
//                     dummyText: ["*			Overview of sand, die, and investment casting..", "*Common defects and their impact on quality.",],
//                 },
//                 {
//                     id: 2,
//                     text: "•	 	Welding Processes Introduction to arc, MIG, and TIG welding techniques",
//                     dummyText: [,],
//                 },
//                 {
//                     id: 3,
//                     text: "•	 	Metal Forming Techniques ",
//                     dummyText: ["*	Forging, rolling, and extrusion: Methods and applications.","*	Cold vs. Hot Forming: Differences and use cases."],
//                 },
//                 {
//                     id: 4,
//                     text: "•	 	Material Removal Processes  ",
//                     dummyText: ["*		Conventional Methods: Turning, milling, and grinding.","*		Advanced Techniques: Basics of EDM (Electrical Discharge Machining)."],
//                 },
//             ],
//         },
//         {
//             id: 3,
//             title: "Mechanical Design and Automation  ",
//             nestedContent: [
//                 {
//                     id: 1,
//                     text: "•		Design and Drafting ",
//                     dummyText: ["*			Mechanical Design Basics: Understanding the design process and factors of safety.", "*		Engineering Drawing: Overview of 2D/3D projections, sectional views, and assembly drawings.",],
//                 },
//                 {
//                     id: 2,
//                     text: "•		Automation and Industrial Processes  ",
//                     dummyText: ["*			Understanding Automation: Applications in modern industries.","*		PLC and CNC Basics: Introduction to programming and their role in precision and efficiency.",],
//                 },
//             ],
//         },
//         {
//             id: 4,
//             title: "Materials and Mechanisms   ",
//             dummyText: [,],
//             nestedContent: [
//                 {
//                     id: 1,
//                     text: "•		Material Science and Selection ",
//                     dummyText: ["*	Properties of Materials: Mechanical and thermal properties.","*	Composite Materials: Overview of types and their applications.","*	Composite Materials: Overview of types and their applications."],
//                 },
//                 {
//                     id: 2,
//                     text: "•	 	Kinematics of Machinery  ",
//                     dummyText: ["*				Introduction to Kinematics: Linkages, joints, and motion types.","	*	Mechanism Design: Automotive wipers, robotic arms, and other case studies.",],
//                 },
//             ],
//         },
//     ];

//     return (
//         <div className="container my-5">
//             <div className="list-tab" style={{ width: "100%", padding: 0 }}>
                
//             {listContent.map(({ id, title, content, nestedContent }, index) => (
//                     <div key={id} className="mb-3" style={{ width: "100%" }}>
//                         <div
//                             className={`p-3 rounded cursor-pointer d-flex justify-content-between align-items-center`}
//                             onClick={() => updateToggle(id)}
//                             style={{
//                                 width: "100%",
//                                 boxShadow: id === 0 ? 'none' : '0px 4px 8px rgba(0, 0, 0, 0.1)',
//                                 backgroundColor: id === 0 ? 'transparent' : '#f8f9fa', // Make 0 background transparent
//                             }}
//                         >
//                             <span
//                                 className={`fw-bold`}
//                                 style={{
//                                     fontFamily: "Roboto",
//                                     fontSize: index === 0 ? "19px" : "20px",
//                                     color: index === 0 ? "#0072FF" : undefined,
//                                 }}
//                             >
//                                 {title}
//                             </span>
//                             {index !== 0 && (
//                                 <span style={{ fontSize: "20px" }}>
//                                     {toggle === id ? "-" : "+"}
//                                 </span>
//                             )}
//                         </div>
//                         {/* Add line below first item */}
//                         {/* {index === 0 && (
//                             <div
//                                 style={{
//                                     height: "1px",
//                                     backgroundColor: "orange",
//                                     width: "20%",
//                                      margin: "-13px",
//                                      marginLeft: '50px',
//                                 }}
//                             ></div>
//                         )} */}
//                                 {/* {title}
//                             </span>
//                             {id !== 0 && <span style={{ fontSize: "20px" }}>{toggle === id ? "-" : "+"}</span>}
//                         </div>
//                         {id === 0 && toggle === id && (
//                             <div className="mt-2" style={{ textAlign: "center" }}>
//                                 <div style={{ width: "35px", height: "2px", backgroundColor: "#555", margin: "10px auto" }} />
//                             </div>
//                         )} */}
                        
//                         {toggle === id && id !== 0 && (
//                             <div className="mt-2 px-4">
//                                 {content && <p style={{ fontFamily: "Roboto" }}>{content}</p>}
//                                 {nestedContent.map(({ id: nestedId, text, dummyText }) => (
                                    
//                                     <div key={nestedId} className="my-2">
//                                         <div
//                                             className="p-2 bg-white rounded cursor-pointer d-flex justify-content-between align-items-center"
//                                             onClick={() => updateNestedToggle(nestedId)}
//                                             style={{ border: "1px solid #ddd" }}
//                                         >
//                                             <span style={{ fontFamily: "Roboto", fontSize: "18px" }}>{text}</span>
//                                             <span style={{ fontSize: "18px" }}>
//                                                 {nestedToggle[nestedId] ? "-" : "+"}
//                                             </span>
//                                         </div>
//                                         {nestedToggle[nestedId] && (
//                                             <div className="mt-2 px-3">
//                                                 <ul style={{ fontFamily: "Roboto", color: "#555" }}>
//                                                     {dummyText.map((item, index) => (
//                                                         <li key={index}>{item}</li>
//                                                     ))}
//                                                 </ul>
//                                             </div>
//                                         )}
//                                     </div>
//                                 ))}
//                             </div>
//                         )}
//                     </div>
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default LearningPathTFD;





import React, { useState } from "react";

const LearningPathTFD = () => {
  const [toggleAllSections, setToggleAllSections] = useState(false);
  const [sectionToggle, setSectionToggle] = useState({});
  const [toggleNewModule, setToggleNewModule] = useState(false);
  const [newModuleToggle, setNewModuleToggle] = useState({});
  const [toggleExteraModule, setToggleExteraModule] = useState(false);
  const [exteraModuleToggle, setExteraModuleToggle] = useState({});
  const [toggleIsExteraModule, setToggleIsExteraModule] = useState(false);
  const [isExteraModuleToggle, setIsExteraModuleToggle] = useState({});
  const [toggleAdditionalModule, setToggleAdditionalModule] = useState(false);
  const [additionalModuleToggle, setAdditionalModuleToggle] = useState({});
  const [toggleExtraAdvancedModule, setToggleExtraAdvancedModule] = useState(false);
  const [extraAdvancedModuleToggle, setExtraAdvancedModuleToggle] = useState({});
  const [toggleAndLocalModule, setToggleAndLocalModule]= useState(false);
  const [AndLocalModuleToggle, setAndLocalModuleToggle]= useState({});
  const [toggleAndUlteraLocalModule, setToggleAndUlteraLocalModule]= useState(false);
  const [AndUlteraLocalModuleToggle, setAndUlteraLocalModuleToggle]= useState({});
  const listContent = [
    // Existing sections
    {
      id: 1,
      title: " What is Virtual Simulation? ",
      nestedContent: [
        { id: 1, text: "• 		Definition and principles", dummyText: [] },
        { id: 2, text: "•	Difference between virtual simulation, augmented reality, and virtual reality", dummyText: [] },
       
      ],
    },

    {
      id: 2,
      title: "Why Virtual Simulation Matters?",
      nestedContent: [
        { id: 1, text: "•  Importance in training, design, testing, and decision-making..", dummyText: [] },
        
       
      ],
    },
    
  ];

  const newModuleContent = [
    // New module sections
    { 


      id: 1,
      title1:'Manufacturing Processes',
      title: "  Physical Simulation",
      nestedContent: [
        { id: 1, text: "• 		Simulation of physical systems using virtual models", dummyText: [""] },
        { id: 2, text: "• 		Examples: Mechanical stress testing, aerodynamic simulations", dummyText: [] },
       
      ],
    },
    {
      id: 2,
      title: "   Process Simulation",
     nestedContent: [
        { id: 1, text: "• 		Virtual replication of industrial or business processes.", dummyText: [""] },
        { id: 2, text: "• 		Examples: Supply chain, manufacturing workflows", dummyText: [] },
       
      ],
    },


    {
        id: 3,
        title: "  Interactive Simulation",
        nestedContent: [
          { id: 1, text: "• 		User-interactive systems for testing and training", dummyText: [] },
          { id: 2, text: "• 		Examples: Flight simulators, surgical training systems", dummyText: [] },
         
        ],
      },
      {
        id: 4,
        title: "   Immersive Simulation",
        nestedContent: [
          { id: 1, text: "• 			High-level immersion through VR/AR tools", dummyText: [] },
           { id: 1, text: "• 			 Examples: Virtual reality training environments", dummyText: [] },
         
        ],
      },
      
     
      
  ];

  const exteraModuleContent = [
    // Extra module sections
    {
      id: 3,
      title: " • Cost Efficiency",
      nestedContent: [
        { id: 1, text: "• 			* Reduction of physical prototyping and errors", dummyText: [] },
          
       
      ],
    },
    {
      id: 4,
      title: "  Risk Reduction",
      nestedContent: [
        { id: 1, text: "• 			* Safe testing of hazardous or complex scenarios", dummyText: [] },
     
        
      ],
    },
    {
        id: 5,
        title: " Improved Learning and Training",
        nestedContent: [
          { id: 1, text: "• 		* Enhanced engagement and practical understanding.", dummyText: [] },
          
          
        ],
      },

      {
        id: 6,
        title: " Faster Iteration Cycles",
        nestedContent: [
          { id: 1, text: "• 		Quick testing and refinement of designs and processes.", dummyText: [] },
         
          
        ],
      },


      {
        id: 7,
        title: "  Global Accessibility",
        nestedContent: [
          { id: 1, text: "• 		Remote collaboration and access to simulated environments.", dummyText: [] },
         
          
        ],
      },
  ];









  const additionalModuleContent = [
    // Additional module sections
    {
      id: 5,
      title: "  Industrial Applications:",
      nestedContent: [
        { id: 1, text: "•			Manufacturing: Assembly line optimization, workflow simulation", dummyText: [] },
        { id: 2, text: "•			 Robotics: Robot motion planning and task simulations.", dummyText: [] },
      ],
    },
    {
      id: 6,
      title: " Medical Applications",
      nestedContent: [
        { id: 1, text: "• 			Surgery training and diagnostics using virtual environments.", dummyText: [] },
       
      ], 
    },
{
      id: 6,
      title: " Education and Training",
      nestedContent: [
        { id: 1, text: "• 			 Simulated labs for engineering and science education.", dummyText: [] },
       
      ],
    },

    {
      id: 6,
      title: " Military and Defense",
      nestedContent: [
        { id: 1, text: "• 			Combat and tactical training using immersive simulations..", dummyText: [] },
        
      ],
    },

    {
      id: 6,
      title: " Transportation",
      nestedContent: [
        { id: 1, text: "• 			 Flight and vehicle simulators for operator training..", dummyText: [] },
        
      ],
    },

    {
      id: 6,
      title: " Entertainment",
      nestedContent: [
        { id: 1, text: "• 			Gaming and immersive storytelling..", dummyText: [] },
       
      ],
    },


    
      
      
  ];






  const isExteraModuleContent = [
    // Additional Module Sections
    {
      id: 7,
      title: " Overview of Common Tools",
      nestedContent: [
        { id: 1, text: "• 			 Process Simulate ,Delmia,Visual Components,Robostudio,Robcaed", dummyText: [] },
        
      ],
    },

    {
      id: 8,
      title: "Hands-On Overview",
      nestedContent: [
        { id: 1, text: "• 			Quick exploration of a selected software", dummyText: [] },
        { id: 2, text: "• 			Demonstration of basic simulation workflow", dummyText: [] },
      ],
    }, 

    
      
  ];

  
  

  

  const toggleSection = (id, module = "existing") => {
    if (module === "existing") {
      setSectionToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "new") {
      setNewModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "extera") {
      setExteraModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "isextera") {
      setIsExteraModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "additional") {
      setAdditionalModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "extraAdvanced") {
      setExtraAdvancedModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    }else if (module === "andLocal"){
        setAndLocalModuleToggle((prev) => ({...prev,[id]: !prev[id]}));
   } else if (module === "andUlteraLocal"){
    setAndUlteraLocalModuleToggle((prev) => ({...prev,[id]: !prev[id]}));
  }
  };
  
  return (
    <div className="container my-5">
      
      <br />
      
      {/* Existing Module */}
      <div
  className="fw-bold mb-4 p-3 bg-light rounded"
  style={{
    color: "blue",
    fontFamily: "Roboto",
    fontSize: "20px",
    cursor: "pointer",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }}
  onClick={() => setToggleAllSections(!toggleAllSections)}
>
  Introduction Of Virtual Simulation

  {/* <span
    style={{
      display: "inline-block",
      width: "28px",
      height: "28px",
      borderRadius: "50%",
      backgroundColor: "#007bff",
      color: "white",
      fontWeight: "bold",
      fontSize: "18px",
      lineHeight: "28px",
      textAlign: "center"
    }}
  >
    {newModuleToggle[""] ? "−" : "+"}
  </span> */}
</div>

      {toggleAllSections && (
        <div className="list-tab mt-3">
          {listContent.map(({ id, title, nestedContent, }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id)}
              >
                {title}
                <span>{sectionToggle[id] ? "-" : "+"}</span>
              </div>
              {sectionToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* New Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleNewModule(!toggleNewModule)}
      >
     Types of Virtual Simulation
      </div>
      

      {toggleNewModule && (
        <div className="list-tab mt-3">
          {newModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "new")}
              >
                {title}
                <span>{newModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {newModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Extera Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleExteraModule(!toggleExteraModule)}
      >
       Benefits of Virtual Simulation
      </div>

      {toggleExteraModule && (
        <div className="list-tab mt-3">
          {exteraModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "extera")}
              >
                {title}
                <span>{exteraModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {exteraModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Additional Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAdditionalModule(!toggleAdditionalModule)}
      >
        Applications of Virtual Simulation
      </div>

      {toggleAdditionalModule && (
        <div className="list-tab mt-3">
          {additionalModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "additional")}
              >
                {title}
                <span>{additionalModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {additionalModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

<div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleIsExteraModule(!toggleIsExteraModule)}
      >
    Virtual Simulation Software Tools
      </div>

      {toggleIsExteraModule && (
        <div className="list-tab mt-3">
          {isExteraModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "isextera")}
              >
                {title}
                <span>{isExteraModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {isExteraModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      {/* Extra Advanced Module */}
      

     

      

     
      
    </div>
  );
};

export default LearningPathTFD;
